var modal = $("#ctu_modal");
var loadingModal = $("#loading_modal");
var contentModal = $("#content_modal");
var datatable;
var anno = null; //(new Date()).getFullYear();
var periti = null;
var categoria_list;
var categoria_id = null;
var specilizzazione = 0;

modal.on('hidden.bs.modal', function (e) {
    loadingModal.show();
    contentModal.hide();
});

function filterGlobal(val) {
    datatable.search(val).draw();
}

function loadModalShowCtu(id) {
    var url = "/ctu/" + id + "/show_modal";
    modal.modal();
    $.ajax({
        type: "GET",
        url: url,
        success: function (response) {
            loadingModal.hide();
            contentModal.html(response).show();
        },
        error: function (xhr, status) {
            loadingModal.show();
            alert('errore: ' + status);
        }
    });
}

function changeCategoria(id, anno, periti, specilizzazione) {
    var url = null;
    if (id > 0) {
        var encode_spec = "";
        if (specilizzazione) {
            encode_spec = "&specializzazione=" + specilizzazione.join('_');
        }
        url = '/ctu/ajax/categoria/' + id + '?anno=' + anno + '&periti=' + periti + encode_spec;
        datatable.ajax.url(url).load();
        filterGlobal('');
    } else {
        url = '/ctu/ajax' + '?anno=' + anno + '&periti=' + periti;
        datatable.ajax.url(url).load();
        filterGlobal('');
    }
}

function getSpecializzazioneByIds(ids) {
    var specializzazioniSelect = $('#specializzazioni_list').select2();
    if (ids) {
        $.ajax({
            url: '/ctu/categorie/getspecializzazioni',
            method: 'POST',
            data: { ids: [ids] },
            success: function (response) {
                $('#specializzazioni_list').html("");
                var option = new Option('Nessun filtro', 0, false, false);
                specializzazioniSelect.append(option);
                $.each(response, function (i, v) {
                    var option = new Option(i, v, false, false);
                    specializzazioniSelect.append(option);
                });
                specializzazioniSelect.trigger('change');
            },
            error: function (error) {
                console.log(error);
            }
        });
    } else {
        $('#specializzazioni_list').html("");
        // var option = new Option('Nessun filtro', 0, false, false);
        // specializzazioniSelect.append(option);
    }
}

$(function () {
    $(".select2").select2();
    categoria_list = $("#categoria_list").select2();
    specializzazioni_list = $("#specializzazioni_list").select2();
    categoria_list.on('change', function () {
        categoria_id = $(this).val();
        changeCategoria(categoria_id, anno, periti, specilizzazione);
        getSpecializzazioneByIds(categoria_id);
    });
    specializzazioni_list.on('change', function () {
        specilizzazione = $(this).val();
        // var categoria = (specilizzazione == 0 ) ? categoria_id : specilizzazione ;
        changeCategoria(categoria_id, anno, periti, specilizzazione);
    });
    datatable = $('#ctu-table').DataTable({
        "language": datatables_it,
        processing: true,
        serverSide: true,
        searchDelay: 2000,
        ajax: '/ctu/ajax',
        columns: [
            { data: 'id', name: 'id', orderable: false, searchable: false },
            { data: 'cognome', name: 'cognome' },
            { data: 'nome', name: 'nome' },
            {
                data: 'categoria',
                name: 'anagrafiche_ctu_categorie_ctu.categorie_ctu_id',
                orderable: false,
                searchable: false
            },
            { data: 'specializzazioni', name: 'specializzazioni' },
        ],
        order: [[1, "asc"]]
    });

    $('#ctu-table tbody').on('click', 'tr[role="row"]', function () {
        var id_ctu = $(this).find('span').data('id');
        loadModalShowCtu(id_ctu);
    });

    $('#ctu_periti').change(function () {
        periti = $(this).val();

        if (!categoria_id || categoria_id == 0) {
            var url = '/ctu/ajax?anno=' + anno + '&periti=' + periti;
        } else {
            var encode_spec = '';
            if (specilizzazione) {
                encode_spec = "&specializzazione=" + specilizzazione.join('_');
            }
            url = '/ctu/ajax/categoria/' + categoria_id + '?anno=' + anno + '&periti=' + periti + encode_spec;
        }
        datatable.ajax.url(url).load();
        filterGlobal('');
        categoria_list.select2('destroy');
        $("#categoria_list option").prop('disabled', false);
        if (periti == 2 || periti == 3) {
            $("#categoria_list").find('.ctu:not(.perito)').prop('disabled', true);
        } else if (periti == 1) {
            $("#categoria_list ").find('.perito:not(.ctu)').prop('disabled', true);
        } else {
            $("#categoria_list option").prop('disabled', false);
        }
        setTimeout(function () {
            categoria_list = $("#categoria_list").select2();
        }, 300);
    });

    $('#filtro_anno').change(function () {
        anno = $(this).val();
        $('.anno').text(anno);
        if (!categoria_id || categoria_id == 0) {
            var url = '/ctu/ajax?anno=' + anno + '&periti=' + periti;
        } else {
            var encode_spec = '';
            if (specilizzazione) {
                encode_spec = "&specializzazione=" + specilizzazione.join('_');
            }
            url = '/ctu/ajax/categoria/' + categoria_id + '?anno=' + anno + '&periti=' + periti + encode_spec;
        }
        datatable.ajax.url(url).load();
        filterGlobal('');
    });

});

var datatables_it = {
    "sEmptyTable": "Nessun dato presente nella tabella",
    "sInfo": "Vista da _START_ a _END_ di _TOTAL_ elementi",
    "sInfoEmpty": "Vista da 0 a 0 di 0 elementi",
    "sInfoFiltered": "(filtrati da _MAX_ elementi totali)",
    "sInfoPostFix": "",
    "sInfoThousands": ".",
    "sLengthMenu": "Visualizza _MENU_ elementi",
    "sLoadingRecords": "Caricamento...",
    "sProcessing": "Elaborazione...",
    "sSearch": "Cerca:",
    "sZeroRecords": "La ricerca non ha portato alcun risultato.",
    "oPaginate": {
        "sFirst": "Inizio",
        "sPrevious": "Precedente",
        "sNext": "Successivo",
        "sLast": "Fine"
    },
    "oAria": {
        "sSortAscending": ": attiva per ordinare la colonna in ordine crescente",
        "sSortDescending": ": attiva per ordinare la colonna in ordine decrescente"
    }
};